
export default {
  name: 'BaseProfileAuthorContacts',
  props: {
    contacts: {
      type: Object,
      default: null,
    },
    authorId: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: 'Контакты',
    },
  },
  computed: {
    isAuthor() {
      if (this.$auth.loggedIn && this.authorId) {
        return this.$auth?.user?._id === this.authorId
      } else {
        return false
      }
    },
    isHasContacts() {
      return (
        this.contacts?.address ||
        this.contacts?.email ||
        this.contacts?.phone ||
        this.contacts?.website ||
        this.isHasSocialContacts
      )
    },
    isHasSocialContacts() {
      return (
        this.contacts?.twitter ||
        this.contacts?.youtube ||
        this.contacts?.telegram ||
        this.contacts?.vk ||
        this.contacts?.ok ||
        this.contacts?.yandexzen
      )
    },
  },
}
